// extracted by mini-css-extract-plugin
export var fadeInOut = "_1l-3";
export var icon = "_1l-4";
export var savedIndicator = "_1l-2";
export var savingIndicator = "_1l-0";
export var spin = "_1l-1";